const validateAddress = (address: string, country: unknown) => {
  // validation happens only if address or country is filled
  if ((address || country) && (!address || !country)) {
    return 'Pro uložení adresy je potřeba zadat adresu a zemi';
  }
  return undefined;
};
export default validateAddress;
